// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wFLE","input":"styles_input__2XldV"};